// removed by extract-text-webpack-plugin
module.exports = {"mediaWrapper":"_33w2hGrMVFtelTBK8tHMLb","isLandingPage":"iAcj6whDcI2DSbi7_WvS4","childWrapper":"_3aMrjROwlp_qmvgVzhFApY","bottomAligned":"_18wUHCyLZjBsnNQfA-QEpF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MediaWrapper/MediaWrapper.module.scss
// module id = 788
// module chunks = 0